import React from "react";

function EnglishPolicy() {
  return (
    <section className="max-w-4xl mx-auto px-4 py-10 text-gray-800 text-left">
      <h1 className="text-3xl font-bold mb-4">Polar Water LLC / Polar Water Filtration - Privacy Policy</h1>
      <p className="text-sm text-gray-500 mb-8">
        Effective Date: <strong>2/1/2024</strong> <br /> Last Updated: <strong>12/5/2024</strong>
      </p>

      <p className="mb-4">
      <strong>Polar Water LLC, also known as Polar Water Filtration</strong> ("we," "our," or "us"), respects your privacy. This Privacy Policy explains how we collect, use, and protect your information when you interact with us through our website, advertisements, and contact forms on platforms like Meta (Facebook & Instagram), Google Ads, and Yelp.
      </p>

      <h2 className="text-2xl font-semibold mt-8 mb-2">1. Information We Collect</h2>
      <ul className="list-disc list-inside space-y-2 mb-4">
        <p>When you fill out a form, request information, or contact us, we may collect:</p>
        <li>
          <strong>Personal Information</strong> – Your name, phone number, email address, and zip code.
        </li>
        <li>
          <strong>Service Preferences</strong> – Whether you own or rent, your water concerns, and your interest in our products.
        </li>
        <li>
          <strong>Website & Ad Interactions</strong> – Information about how you engage with our ads and website.
        </li>
      </ul>

      <h2 className="text-2xl font-semibold mt-8 mb-2">2. How We Use Your Information</h2>
      <ul className="list-disc list-inside space-y-2 mb-4">
      <p>We use the collected data to:</p>
        <li>Provide personalized water filtration solutions.</li>
        <li>Respond to inquiries and schedule consultations.</li>
        <li>Improve our advertising, customer service, and website experience.</li>
      </ul>

      <h2 className="text-2xl font-semibold mt-8 mb-2">3. Data Protection & Sharing</h2>
      <ul className="list-disc list-inside space-y-2 mb-4">
        <li>We do not sell, rent, or share your personal information with third parties.</li>
        <li>Your data is stored securely and used only for Polar Water’s business purposes.</li>
        <li>We may use Google, Meta, or Yelp’s advertising tools to retarget ads to interested users.</li>
      </ul>

      <h2 className="text-2xl font-semibold mt-8 mb-2">4. Your Choices & Rights</h2>
      <ul className="list-disc list-inside space-y-2 mb-4">
      <p>You can:</p>
        <li><strong>Opt Out of Communications</strong> – Unsubscribe from emails or request removal from contact lists.</li>
        <li><strong>Request Data Deletion</strong> – Contact us to remove your personal data from our system.</li>
      </ul>

      <h2 className="text-2xl font-semibold mt-8 mb-2">5. Contact Us</h2>
      <p className="mb-2">
        If you have any questions or want to manage your data, contact us at:
      </p>
      <p className="mb-1">
        📧 Email:{" "}
        <a
          href="mailto:polarwaterllc@gmail.com"
          className="text-blue-600 hover:underline"
        >
          polarwaterllc@gmail.com
        </a>
      </p>
      <p>📞 Phone: (951) 212-5633</p>
    </section>
  );
}

export default EnglishPolicy;
